<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-people`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.30859 17.8132C2.30859 17.3609 2.30859 17.1348 2.32687 16.9442C2.50983 15.037 4.01945 13.5274 5.92663 13.3445C6.11718 13.3262 6.34334 13.3262 6.79566 13.3262H17.205C17.6573 13.3262 17.8835 13.3262 18.074 13.3445C19.9812 13.5274 21.4908 15.037 21.6738 16.9442C21.6921 17.1348 21.6921 17.3609 21.6921 17.8132C21.6921 18.0394 21.6921 18.1525 21.6829 18.2478C21.5915 19.2013 20.8367 19.9562 19.8831 20.0476C19.7878 20.0568 19.6747 20.0568 19.4485 20.0568H4.55213C4.32597 20.0568 4.21288 20.0568 4.11761 20.0476C3.16402 19.9562 2.40921 19.2013 2.31773 18.2478C2.30859 18.1525 2.30859 18.0394 2.30859 17.8132Z" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><rect x="8.391" y="3.2" width="7.22" height="7.22" rx="3.61" stroke="#00BBD8" stroke-width="1.66" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorPeople',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
